import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const OurOfferingVisionMultimodal = () => {
    return (
        <div className="section-py !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Vision and Multimodal Offerings
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/vision-and-multimodal-ai/svg/ic-custom-object-detection.svg" width={36} height={36} alt="Custom object detection" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">Custom object detection and classification models</p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/vision-and-multimodal-ai/svg/ic-semantic-segmentation.svg" width={36} height={36} alt="Semantic segmentation" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Semantic segmentation and instance recognition
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-optical-character-.svg"
                                width={36}
                                height={36}
                                alt="Optical Character Recognition"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Optical Character Recognition (OCR) and document intelligence
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-video-analytics.svg"
                                width={36}
                                height={36}
                                alt="Video analytics"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Video analytics: activity recognition, anomaly detection, tracking
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-multimodal-ai-vision.svg"
                                width={36}
                                height={36}
                                alt="Multimodal AI"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Multimodal AI: vision + language understanding (VQA, image captioning)
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-face-detection.svg"
                                width={36}
                                height={36}
                                alt="Face detection"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Face detection, recognition, and biometric systems
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-edge-ai-deployment.svg"
                                width={36}
                                height={36}
                                alt="Edge AI deployment"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Edge AI deployment: model optimization for IoT, drones, cameras
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/vision-and-multimodal-ai/svg/ic-3d-vision.svg" width={36} height={36} alt="3D vision" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           3D vision: depth estimation, point cloud processing, SLAM
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-synthetic-data.svg"
                                width={36}
                                height={36}
                                alt="Synthetic data generation"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Synthetic data generation for training robustness
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/vision-and-multimodal-ai/svg/ic-explainable-ai-dashboard.svg" width={36} height={36} alt="Explainable AI" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Explainable AI dashboards & MLOps for vision: versioning, monitoring, retraining pipelines
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-ready-transform rounded-10 relative">
                    <div className="counter-overlay"></div>
                    <div className="lg:col-span-12 lg:p-12 md:p-5 p-5 relative z-[1]">
                        <h2 className="mb-3 text-white">Ready to Transform Your Enterprise Knowledge into Intelligent Action?</h2>
                        <p className="mb-3 text-white">
                            Request a demo to see production-ready RAG pipelines and enterprise chatbots in action
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurOfferingVisionMultimodal;
